// import {loginTitle} from '../../../../different/js/different.js'
let loginTitle = '城投助农';
let settingTitle = '城投助农';
let cityName = '泸州市'

// 针对柳州
let  WaitEventManageStatus = true; //待处理事项 按钮状态
let OffRoadParkingRouterStatus = true; //停车场路由 状态

// 针对三台
let  carPrint = true;//基础数据——车场画像 路由状态
let isPrePayStatus = false; // true：关闭预缴，false:开启预缴


module.exports = {
    loginTitle,
    settingTitle,
    cityName,
    WaitEventManageStatus,
    OffRoadParkingRouterStatus,
    carPrint,isPrePayStatus
}